// Canonical Pokemon type colors — single source of truth.
// All type color hex values across the codebase derive from here.

export const TYPE_COLORS = {
  normal:   '#A8A878',
  fire:     '#F08030',
  water:    '#6890F0',
  electric: '#F8D030',
  grass:    '#78C850',
  ice:      '#98D8D8',
  fighting: '#C03028',
  poison:   '#A040A0',
  ground:   '#E0C068',
  flying:   '#A890F0',
  psychic:  '#F85888',
  bug:      '#A8B820',
  rock:     '#B8A038',
  ghost:    '#705898',
  dragon:   '#7038F8',
  dark:     '#705848',
  steel:    '#B8B8D0',
  fairy:    '#EE99AC',
};

// Types whose background is light enough to need dark text
const TYPE_DARK_TEXT = new Set(['electric', 'ice', 'normal', 'ground']);

export function getTypeColor(type) {
  return TYPE_COLORS[type?.toLowerCase()] ?? '#A8A878';
}

export function getTypeTextColor(type) {
  return TYPE_DARK_TEXT.has(type?.toLowerCase()) ? '#333333' : '#ffffff';
}
